var ButtonMessagePopup = require("app/AppLayout/ButtonMessagePopup"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    kind               = require("enyo/kind");

require("app/theme/IconButton--negative.less");

module.exports = kind(/** @lends  app.Sharing.ShareFailMessage.prototype */ {

    /**
     * @private
     */
    name: "app.Sharing.ShareFailMessage",

    /**
     * @private
     */
    kind: ButtonMessagePopup,

    /**
     * @private
     */
    classes: "app-sharing-share-fail-message",

    /**
     * @private
     */
    handlers: {
        onMessageButtonTap: "onMessageButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.$.message.$.button.set("theme", "negative");
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.Sharing.ShareFailMessage.title"));
        $message.$.body.set("content", i18nService.getString("app.Sharing.ShareFailMessage.body"));
        $message.$.button.set("caption", i18nService.getString("app.Sharing.ShareFailMessage.Button.caption"));
        $message.$.button.set("tooltip", i18nService.getString("app.Sharing.ShareFailMessage.Button.tooltip"));
    },

    /**
     * Close the popup
     *
     * @private
     */
    onMessageButtonTap: function() {
        this.close();
    }

});
